<!-- container start -->
<div class = "edit-shift-modal">
  <!-- header starts -->

    <div class="cross-icon">

      <i class="fa fa-times cross-icon" (click)="dismiss()"></i>
    </div>


    <div  class = "header">
      
      <div class="img-container">
        <img alt="alert" src="assets/images/siren.png">
      </div>
      <ion-label class = "heading">{{data?.headerText || 'Delete recurring shift'}}</ion-label>
    

    </div>

  <!-- header ends -->

  <!-- content starts -->

  <div class = "body">

   
    
    <ion-label class = "heading confirmation-heading">{{
    data?.messageText || 'This action will delete all current and future recurrences of this shift. If you want to delete or edit one or more individual recurrences, please click "Edit Icon" instead.'  
    }}</ion-label>

  </div>

  <!-- content ends -->
  

  
  
  <!-- footer starts -->
  <div class = "footer">
    <div class = "button-container">
      <ion-button class = "discard" (click) = "dismiss()">Cancel</ion-button>
      <ion-button class = "confirm" (click) = "onSave()">{{ data?.buttonText || 'Delete Recurring Shift'}}</ion-button>
    </div>
  </div>
  <!-- footer ends -->
  
  
  </div>
  <!-- container ends -->